import React from 'react'
import { Typography, useTheme } from '@material-ui/core'
import { useIntl } from 'gatsby-plugin-intl'
import { useStyles } from './LinkWithIcon.style'
import { LinkIcon } from '../SVGIcons'
import Link from '../Link'
import ArrowIcon from '../ArrowIcon'

const LinkWithIcon = ({ text, icon, ...linkProps }) => {
  const styles = useStyles()
  const theme = useTheme()
  const { locale } = useIntl()

  return (
    <Typography variant="body1">
      <Link className={styles.link} {...linkProps}>
        {text}{' '}
        {icon || linkProps.isExternal ? (
          <LinkIcon fill={`${theme.palette.text.link}`} />
        ) : (
          <ArrowIcon locale={locale} direction={'forward'} />
        )}
      </Link>
    </Typography>
  )
}

export default LinkWithIcon
